import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as t from 'io-ts';

var KeysWithMapType = /*#__PURE__*/function (_t$Type) {
  _inherits(KeysWithMapType, _t$Type);

  var _super = _createSuper(KeysWithMapType);

  function KeysWithMapType(name, is, validate, encode, keys, map) {
    var _this;

    _classCallCheck(this, KeysWithMapType);

    _this = _super.call(this, name, is, validate, encode);
    _this.name = name;
    _this.is = is;
    _this.validate = validate;
    _this.encode = encode;
    _this.keys = keys;
    _this.map = map;

    _defineProperty(_assertThisInitialized(_this), "_tag", 'KeysWithMapType');

    return _this;
  }

  return _createClass(KeysWithMapType);
}(t.Type); // disabling this rule since this provides an opaque alias for the type
// eslint-disable-next-line @typescript-eslint/no-empty-interface


export function keysWithMap(keys, name) {
  var codec = t.keyof(keys, name);
  return new KeysWithMapType(codec.name, codec.is, codec.validate, codec.encode, codec.keys, Object.fromEntries(Object.entries(keys).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return [v, k];
  })));
}